/**
 * Regional market profiles (M8). Client Views default to CO when market is omitted.
 */
export const DEFAULT_MARKET_CODE = "CO";

export const MARKET_PROFILES = {
  CO: {
    marketCode: "CO",
    country: "Colombia",
    defaultLocale: "es-CO",
    defaultCurrency: "COP",
    supportedLocales: ["es-CO", "en-US", "ru-RU"],
    supportedCurrencies: ["COP", "USD", "EUR", "RUB"],
    priceStorageCurrency: "COP",
    measurementSystem: "metric",
    distanceUnit: "km",
    areaUnit: "m2",
  },
  MX: {
    marketCode: "MX",
    country: "México",
    defaultLocale: "es-MX",
    defaultCurrency: "MXN",
    supportedLocales: ["es-MX", "en-US"],
    supportedCurrencies: ["MXN", "USD"],
    priceStorageCurrency: "MXN",
    measurementSystem: "metric",
    distanceUnit: "km",
    areaUnit: "m2",
  },
  BR: {
    marketCode: "BR",
    country: "Brasil",
    defaultLocale: "pt-BR",
    defaultCurrency: "BRL",
    supportedLocales: ["pt-BR", "en-US"],
    supportedCurrencies: ["BRL", "USD", "EUR"],
    priceStorageCurrency: "BRL",
    measurementSystem: "metric",
    distanceUnit: "km",
    areaUnit: "m2",
  },
  FR: {
    marketCode: "FR",
    country: "France",
    defaultLocale: "fr-FR",
    defaultCurrency: "EUR",
    supportedLocales: ["fr-FR", "en-US"],
    supportedCurrencies: ["EUR", "USD"],
    priceStorageCurrency: "EUR",
    measurementSystem: "metric",
    distanceUnit: "km",
    areaUnit: "m2",
  },
};

export function getMarketProfile(marketCode) {
  const code = String(marketCode || DEFAULT_MARKET_CODE).trim().toUpperCase();
  return MARKET_PROFILES[code] || MARKET_PROFILES[DEFAULT_MARKET_CODE];
}

export function normalizeManifestMarket(rawMarket) {
  const code = rawMarket?.code || rawMarket?.marketCode || DEFAULT_MARKET_CODE;
  const profile = getMarketProfile(code);
  return {
    code: profile.marketCode,
    country: rawMarket?.country || profile.country,
    primaryCurrency: rawMarket?.primaryCurrency || profile.defaultCurrency,
    priceStorageCurrency: rawMarket?.priceStorageCurrency || profile.priceStorageCurrency,
  };
}

export function resolveManifestMarket(manifest) {
  return normalizeManifestMarket(manifest?.market);
}

export function getMarketProfileForManifest(manifest) {
  const market = resolveManifestMarket(manifest);
  return getMarketProfile(market.code);
}
